import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/procedural.webp";
import video from "../assets/vid/procedural-video.mp4";
import Video from 'src/components/Video';


export const projectDetails: ProjectInterface = {
    url: "procedural-study",
    title: "Procedural Generation",
    summary: "Project made to study procedural terrain generation in Unity.",
    description: `Project made to study procedural terrain generation in Unity, following [Sebastian Lague’s YouTube series](https://www.youtube.com/playlist?list=PLFt_AvWsXl0eBW2EiBtl_sxmDtSgZBxB3). I got to play around with cool stuff like Perlin noise, mesh generation, and other systems to create these dynamic, customizable landscapes. It was really fun to see how all these algorithms come together.

Honestly, it was a great way to learn the basics of procedural generation and see how it can be applied in game development. I mean, who doesn’t want to make their own little world, right? But yeah, it was also a bit challenging at times, especially when trying to optimize everything so it runs smoothly. Still, I’m pretty happy with how it turned out, and it definitely gave me a better understanding of how these systems work under the hood.`,
    year: "2022",
    tags: ["Procedural", "Prototype", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.STUDY,
    roles: ["Programmer", "Study"],
    technologies: ["Unity", "C#", "Procedural Generation"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "A procedural adventure in Unity",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/procedural-gen" },
            { type: 'text', url: "https://github.com/lucasctnh/procedural-gen" },
        ],
    relatedProjects: ["RomanceBrawl", "Nodebook", "CheckMore"],
};


export function ProceduralStudy() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                titleSize={2.7}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <Video src={video} />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}